import { render, staticRenderFns } from "./parkvehicletyperule-form.vue?vue&type=template&id=99ebf38c&scoped=true&"
import script from "./parkvehicletyperule-form.vue?vue&type=script&lang=js&"
export * from "./parkvehicletyperule-form.vue?vue&type=script&lang=js&"
import style0 from "./parkvehicletyperule-form.vue?vue&type=style&index=0&id=99ebf38c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ebf38c",
  null
  
)

export default component.exports